import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { JwtInterceptor } from '@/apiConnection/JwtInterceptor';
import { ErrorInterceptor } from '@/apiConnection/ErrorInterceptor';
import { OfflineDataInterceptor } from '@/offline/offline-data.interceptor';
import { environment } from '../../environments/environment';


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // Registered last so it's closest to the network: it must see the raw HttpErrorResponse
    // (status 0 on a real network failure) before ErrorInterceptor's own handling runs on the
    // way back up, and so a cache hit it returns short-circuits ErrorInterceptor entirely.
    { provide: HTTP_INTERCEPTORS, useClass: OfflineDataInterceptor, multi: true },
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ]
};
